import { getCriteria } from '@yandex-int/k-common/client/api/defs/get-criteria';
import { getCriteriaMarks, CRITERIA_MARK_VALUE } from '@yandex-int/k-common/client/api/defs/get-criteria-marks';
import b from 'b_';
import { Link as IconLink } from 'education-icons';
import { Text } from 'platform-components';
import { CriteriaCircle } from 'platform-components/src/components/criteria-circle/criteria-circle';
import React, { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';

import { CriteriaStats } from 'common.components/results/typings';

interface Props {
    problemId: number;
    attemptId: string | null;
    isOpenAnswerEntered: boolean;
    shouldShowTimeValue?: boolean;
    timeValue: string;
    criteriaStatsRef?: React.MutableRefObject<CriteriaStats | undefined>;
}

// eslint-disable-next-line complexity
export const ProblemResultCellOpenAnswer = (props: Props) => {
    const { attemptId, problemId, isOpenAnswerEntered, shouldShowTimeValue, timeValue, criteriaStatsRef } = props;
    const { data: criteriaData } = useQuery(['getCriteria', problemId], () => getCriteria(problemId), {
        enabled: isOpenAnswerEntered,
    });
    const { data: marksData } = useQuery(['getCriteriaMarks', attemptId], () => getCriteriaMarks(attemptId!), {
        enabled: isOpenAnswerEntered && attemptId && criteriaData && criteriaData.length > 0,
    });
    const marks = useMemo(
        () => marksData?.filter((m) => criteriaData?.some((c) => c.id === m.criterion_id)),
        [criteriaData, marksData]
    );
    const criteriaStats = useMemo(() => {
        if (marks?.length && criteriaData) {
            return {
                correct: marks.filter((m) => m.value === CRITERIA_MARK_VALUE.YES).length,
                incorrect: marks.filter((m) => m.value === CRITERIA_MARK_VALUE.NO).length,
                max: criteriaData.length,
            };
        }
        return undefined;
    }, [criteriaData, marks]);
    useEffect(() => {
        if (criteriaStatsRef) {
            criteriaStatsRef.current = criteriaStats;
        }
    }, [criteriaStats, criteriaStatsRef]);

    return (
        <>
            <div
                className={b('results', 'problem-result-open-answer', {
                    'has-answer': isOpenAnswerEntered,
                    'has-criteria': isOpenAnswerEntered && Boolean(criteriaData?.length),
                })}
            >
                {isOpenAnswerEntered && criteriaData && criteriaData.length > 0 && (
                    <CriteriaCircle
                        correct={criteriaStats?.correct || 0}
                        dark={true}
                        gapPercent={9}
                        incorrect={criteriaStats?.incorrect || 0}
                        max={criteriaData.length}
                        mix={b('results', 'problem-result-open-answer-criteria')}
                        showTitle={false}
                        size={16}
                        strokeWidth={2}
                    />
                )}
                <IconLink className="results__problem-result-open-answer-icon" />
            </div>
            {shouldShowTimeValue && <Text size={Text.SIZE.S}>{timeValue}</Text>}
        </>
    );
};
